import { useActivityTimeline } from "@/lib/activityTimeline/useActivityTimeline";
import { FORENSICS_DEFAULT_PAGE_SIZE } from "@/lib/activityTimeline/forensicsPaging";

/** Dev forensics wrapper — platform scope, includes source filter, paged 5/10/25. */
export function useActivityTimelineForensics(opts: { enabled: boolean; organizationId: string }) {
  return useActivityTimeline({
    enabled: opts.enabled,
    scope: "platform",
    organizationId: opts.organizationId,
    includeSourceFilter: true,
    paged: true,
    defaultPageSize: FORENSICS_DEFAULT_PAGE_SIZE,
  });
}
